<template>
    <CustomRouterLink
        :class="menuStyle(route)"
        :style="customStyle(route)"
        :route="route"
        :mini="mini"
        :simpleRote="!route.subMenu && !!route.routeName"
        @click.stop="onClick"
        @mouseenter="onMouseenter"
        @mouseleave="onMouseleave"
    >
        <div
            class="w-full flex items-center flex-nowrap gap-x-3 group relative"
            :class="[route.isOpenSub && !mini && 'mb-1', mini && 'justify-center']"
        >
            <div
                class="w-5 "
                :class="[
                    { 'dark:text-gray-200 ': !mini },
                    { '!text-purple dark:!text-purple-140': !route.isOpenSub && checkCurrentLink(route, route.subMenu) }
                ]"
            >
                <component :is="route.icon()" />
            </div>

            <template v-if="!mini">
                <div class="h-9 flex items-center gap-x-1">
                    <span class="text-center text-xs whitespace-nowrap">
                        {{ route.name }}
                    </span>

                    <div
                        v-if="showAi(route.ai)"
                        class="min-w-6"
                    >
                        <AiIcon24x24 />
                    </div>
                </div>

                <div
                    v-if="route.subMenu"
                    class="flex items-center justify-center ml-auto"
                >
                    <ArrowSubMenuChevronIcon
                        class="w-5 h-5 transform duration-100 text-gray-200"
                        :class="{ 'rotate-180': !route.isOpenSub }"
                    />
                </div>
            </template>

            <div
                v-if="getPendingCounter(route)"
                class="flex items-center justify-center"
                :class="mini ? 'w-2 h-2 top-0 right-1 absolute dark:bg-purple-140 bg-purple rounded-full' : 'ml-auto px-1 min-w-4 h-4 rounded-0.5 bg-purple-300/20'"
            >
                <span
                    v-if="!mini"
                    class="text-primary dark:text-purple-140 text-xs font-medium"
                >
                    {{ getPendingCounter(route) }}
                </span>
            </div>
        </div>

        <RoutingSideBarMini
            v-if="mini && isShowPopup === route.id"
            :route="route"
            :popupPosition="popupPosition"
            @onMouseenter="onPopupMouseenter"
        />

        <RoutingSideBarBig
            v-if="!mini"
            :route="route"
        />
    </CustomRouterLink>
</template>

<script setup>
import { computed } from 'vue'

import CustomRouterLink from '@/components/navigation/CustomRouterLink.vue'
import RoutingSideBarBig from '@/components/navigation/RoutingSideBar/RoutingSideBarBig.vue'
import RoutingSideBarMini from '@/components/navigation/RoutingSideBar/RoutingSideBarMini.vue'
import ArrowSubMenuChevronIcon from '@/components/icons/arrow/ArrowSubMenuChevronIcon.vue'
import AiIcon24x24 from '@/components/icons/AI/AiIcon24x24.vue'

import { useRoutingMenu } from '@/composables/useRoutingMenu'

const props = defineProps({
    route: {
        type: Object,
        default: () => ({}),
    },
    mini: {
        type: Boolean,
        default: false,
    },
    isShowPopup: {
        type: Number,
        default: -1,
    },
    popupPosition: {
        type: Object,
        default: () => ({}),
    },
})

const emits = defineEmits(['openSubMenu', 'mouseenter', 'mouseleave', 'popupMouseenter'])

const {
    menuStyle, customStyle, checkCurrentLink, getPendingCounter, showAi,
} = useRoutingMenu(computed(() => props.mini))

function onClick() {
    emits('openSubMenu', props.route)
}

function onMouseenter(event) {
    emits('mouseenter', props.route, event)
}

function onMouseleave() {
    emits('mouseleave')
}

function onPopupMouseenter(event) {
    emits('popupMouseenter', event)
}
</script>
